import { types } from "./historyCargoShipment.actions";
import { Reducer } from "../../services/reducer.factory";
import moment from "moment";

const initialState = {
  columns:[
    {
        field: "oid",
        header: "Código",
        columnKey: "oid",
        sortable: false,
        filter: false
    },
    {
        field: "origin",
        header: "Origem",
        columnKey: "origin",
        sortable: false,
          filter: false
      },
      {
          field: "destination",
          header: "Destino",
          columnKey: "destination",
          sortable: false,
          filter: false
      },
      {
          field: "carrierName",
          header: "Transportadora",
          columnKey: "carrierName",
          sortable: false,
          filter: false
      },
      {
          field: "createdAt",
          header: "Data de criação",
          columnKey: "createdAt",
          sortable: false,
          filter: false
      },
      {
        field: "active",
        header: "Situação",
        columnKey: "active",
        sortable: false,
        filter: false
      },
      {
        field: "inactiveAt",
        header: "Cancelado",
        columnKey: "inactiveAt",
        sortable: false,
        filter: false
      },
      {
        field: "status",
        header: "Status",
        columnKey: "status",
        sortable: false,
        filter: false
      }
  ],
  filterFields: {
      initialDate: moment().startOf('month').toDate(),
      finalDate: moment().toDate(),
  },
  index: 1,
  max: 10,
  count: 0,
  
};

const reducer = new Reducer(initialState, types);

export function CRUDHistoryCargoShipmentReducer(state = initialState, action) {
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  let result = state;
  switch (action.type) {
    case types.INITIAL_DATE_CHANGE_HANDLER:
      return setInitialDate(state, action);
    case types.FINAL_DATE_CHANGE_HANDLER:
      return setFinalDate(state, action);
    default:
      return result;
  }
}

function setInitialDate(state, action) {
  const filterFields = state.filterFields;
  filterFields.initialDate = action.initialDate;
  return {
    ...state,
    filterFields
  };
}

function setFinalDate(state, action) {
  const filterFields = state.filterFields;
  filterFields.finalDate = action.finalDate;
  return {
    ...state,
    filterFields
  };
}

